// https://github.com/tc39/proposal-using-statement
require('../modules/esnext.symbol.dispose');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/using-statement.js
// module id = YiZg
// module chunks = 2